<template>
  <a-card :bordered="false">
    <SmallSquare class='m-b-25' content="可自定义装修我的积分页面，使得您的个人积分首页更具个性化。" />
    <app-warp title='积分中心' v-on:handleclick="activeModule('page',-1)">
      <template #app-sider-left>
        <div class="moduleContent" style="margin-right:20px">
          <div class="moduleTitle">组件库</div>
          <div class="navs">
            <div class="navs-group">
              <div v-for="(value,index) in modules" :key="index">
                <div class="title">{{value.title}}</div>
                <div class="navs-components ">
                  <nav class="special" v-for="(item,key) in value.modules" :key="key" @click="addModule(item)" :hidden='item.hidden'>
                    <p class="item-icon">
                      <component v-if='item.icon' :is="item.icon"></component>
                    </p>
                    <p>{{item.name}}</p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #app-content>
        <div style="position: relative;">
          <transition-group appear tag="div">
            <template v-for="(item,key) in pageSet.items" :key="key">
                <div class="app-module" @click.stop="activeModule(item.type,key)"
                  :class="moduleIndex==key?'app-active-module':''" @dragstart="dragstart(item,key)"
                  @dragenter="dragenter(item,key)" @dragend="dragend(item)" draggable="true">
                  <component :is="item.type" :data="item" />
                  <div class="app-module-del" @click.stop="delMoudle(key)" :hidden='item.noDel'>
                    <DeleteOutlined style="font-size:18px" />
                  </div>
                </div>
            </template>
          </transition-group>
        </div>
      </template>
      <template #app-sider>
        <div class="moduleContent " style="width:100%;margin-left:20px">
          <a-form :model="form" ref='ruleForm' :label-col="{span:4}" :wrapper-col="{span:18}">
            <template v-for="(value,index) in formCreateData" :key="index">
              <a-form-item :label="value.label" :help="value.help">
                  <!-- 链接 -->
                  <template v-if="value.stamp=='link'">
                    <a-input-search v-model:value="modelRef['items'][moduleIndex][value.key][value.name]"
                      @search="onChooseLink(moduleIndex,-1)" readonly>
                      <template #enterButton>
                        <a-button type="primary">
                          选择
                        </a-button>
                      </template>
                    </a-input-search>
                  </template>
                  <!-- 文本域 -->
                  <template v-if="value.stamp=='textarea'">
                    <a-textarea v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" :rows="4"
                      :help="value.help" />
                  </template>
                  <!-- 普通表单 -->
                  <template v-if="value.stamp=='input'">
                    <a-input v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" :type="value.type"
                      :help="value.help" />
                  </template>
                  <!-- 单选框 -->
                  <template v-if="value.stamp=='radio'">
                    <a-radio-group :options="value.options"
                      v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" />
                  </template>
                  <!-- 复选框 -->
                  <template v-if="value.stamp=='checked'">
                    <a-checkbox v-model:checked="modelRef['items'][moduleIndex][value.key][value.name]"></a-checkbox>
                  </template>
                  <!-- 图片上传 -->
                  <template v-if="value.stamp=='image'">
                    <div v-for="(items,indexs) in modelRef['items'][moduleIndex].data" :key="indexs"
                      class="imagesContent">
                      <a-form-item label="图片" :label-col="{span:4}" :wrapper-col="{span:17}">
                        <material :groupType='1' :image="items['imgUrl']" :max="1"
                          v-on:handlechoose="(data)=>{items['imgUrl']=data}"
                          v-on:handledel="items['imgUrl']=''" />
                      </a-form-item>
                      <a-form-item label="链接地址" :label-col="{span:4}" :wrapper-col="{span:17}">
                        <!-- <a-input v-model:value="items['linkUrl']" /> -->
                        <a-input-search v-model:value="items['linkUrl']" @search="onChooseLink(moduleIndex,indexs)"
                          readonly>
                          <template #enterButton>
                            <a-button type="primary">
                              选择
                            </a-button>
                          </template>
                        </a-input-search>
                      </a-form-item>
                      <CloseOutlined class="images_del" @click="delImagesData(indexs)" />
                    </div>
                    <a-button type="primary" @click="addImagesData(index)">
                      添加一个
                    </a-button>
                  </template>
                  <!-- 单图片上传 -->
                  <template v-if="value.stamp=='singleImage'">
                    <material :groupType='1' :image="modelRef['items'][moduleIndex][value.key][value.name]" :max="1"
                      v-on:handlechoose="(data)=>{modelRef['items'][moduleIndex][value.key][value.name]=data}"
                      v-on:handledel="modelRef['items'][moduleIndex][value.key][value.name]=''" />
                  </template>
                  <!-- 滑动 -->
                  <template v-if="value.stamp=='slider'">
                    <a-slider :tip-formatter="(value)=>value+'px'"
                      v-model:value="modelRef['items'][moduleIndex][value.key][value.name]" />
                  </template>
                  <!--导航-->
                  <template v-if="value.stamp=='nav'">
                    <div v-for="(items,indexs) in modelRef['items'][moduleIndex].data" :key="indexs" class="navContent">
                      <div>
                        <material :groupType='1' :image="items['imgUrl']" :max="1"
                          v-on:handlechoose="(data)=>{items['imgUrl']=data}"
                          v-on:handledel="items['imgUrl']=''" />
                      </div>
                      <div>
                        <div class="s_flex_ali">
                          <div style="width:150px">导航名称:</div>
                          <a-input v-model:value="items['name']" />
                        </div>
                        <div class="s_flex_ali">
                          <div style="width:150px">链接地址:</div>
                          <a-input-search v-model:value="items['linkUrl']" @search="onChooseLink(moduleIndex,indexs)"
                            readonly>
                            <template #enterButton>
                              <a-button type="primary">
                                选择
                              </a-button>
                            </template>
                          </a-input-search>
                        </div>
                      </div>
                      <CloseOutlined class="images_del" @click="delImagesData(indexs)" />
                    </div>
                    <a-button type="primary" @click="addImagesData(index)" block>
                      添加一个
                    </a-button>
                  </template>
                  <!-- 任务组 -->
                  <template v-if="value.stamp=='task'">
                    <div v-for="(items,indexs) in modelRef['items'][moduleIndex].data" :key="indexs"  class="taskContent">
                      <a-form-item label="任务名称" :label-col="{span:4}" :wrapper-col="{span:17}">
                        <a-input v-model:value="items['name']" />
                      </a-form-item>
                      <a-form-item label="任务描述" :label-col="{span:4}" :wrapper-col="{span:17}">
                        <a-textarea v-model:value="items['describe']" :rows="4"
                          :help="value.help" />
                      </a-form-item>
                      <a-form-item label="任务链接" :label-col="{span:4}" :wrapper-col="{span:17}">
                        <!-- <a-input v-model:value="items['linkUrl']" /> -->
                        <a-input-search v-model:value="items['linkUrl']" @search="onChooseLink(moduleIndex,indexs)"
                          readonly>
                          <template #enterButton>
                            <a-button type="primary">
                              选择
                            </a-button>
                          </template>
                        </a-input-search>
                      </a-form-item>
                      <a-form-item label="任务图标" :label-col="{span:4}" :wrapper-col="{span:17}" style='margin-bottom: 0;'>
                        <material :groupType='1' :image="items['imgUrl']" :max="1"
                          v-on:handlechoose="(data)=>{items['imgUrl']=data}"
                          v-on:handledel="items['imgUrl']=''" />
                      </a-form-item>
                      <CloseOutlined class="images_del" @click="delImagesData(indexs)" />
                    </div>
                    <a-button type="primary" @click="addImagesData(index)">
                      添加一个
                    </a-button>
                  </template>
              </a-form-item>
            </template>
          </a-form>
        </div>
        <!-- <img :src="img" alt=""> -->
        <a-button type="primary" @click="onSubmit" class='m-l-30 m-t-10 m-r-10'>
          保存
        </a-button>
      </template>
    </app-warp>
  </a-card>
  <!-- 链接选择 -->
  <a-modal  :keyboard="false" title="链接" centered v-model:visible="linkVisible" :footer="null" :width="1200" destroyOnClose>
    <links v-on:success="selecLink" />
  </a-modal>
</template>
<script>
  import * as Icon from "@ant-design/icons-vue";
  import banner from "./components/banner/index";
  import windows from "./components/windows/index";
  import nav from "./components/nav/index";
  import task from "./components/task/index";
  import header from "./components/header/index";
  import { inject, onMounted, reactive, ref, toRaw, toRefs } from "vue";
  import forms from "./js/form";
  import modules from "./js/modules"; //基础组件数据
  import store from "@/store";
  import { message } from 'ant-design-vue';
  import { getIntegralTemplate, setIntegralTemplate } from '@/api/assets'
  import { iscode } from '@/utils/app';
  export default {
    components: { ...Icon, banner,  nav, windows, task,header },
    setup() {
      const state = reactive({
        form: {
          version_name: '',
          remark: ''
        },
        info: store.state.user.info,
        linkVisible: false,
        modules,
        active: "header", // 默认选中的类型、
        moduleIndex: 0,
        img: '',
        pageSet: {
          items: [
            {
              type:'header',
              name:'背景图',
              noDel: true,
              params:{ imgUrl:'' }
            },
          ],
        }
      });
      const $route = inject('$route')
      const $router = inject('$router')
      var modelRef = ref(state.pageSet);
      onMounted(() => {
        getMore();
      })
      const getMore = async () => {
        let result = await getIntegralTemplate().then(res => res.data).catch(error => error)
        var content = JSON.parse(result.data.content)
        if(content.items.length){
          state.pageSet = content
          modelRef.value=state.pageSet
          state.active = state.pageSet.items[0].type
        }
        formCreate();
      }
      // 读取模块表单数据
      var formCreateData = ref({});
      const formCreate = () => {
        forms.forEach((element) => {
          if (element.type == state.active) {
            formCreateData.value = element.formItems;
          }
        });
      };
      // 激活模块
      const activeModule = (type, index) => {
        state.active = type;
        state.moduleIndex = index;
        formCreate();
      };
      // 追加模块
      const addModule = (item) => {
        modelRef.value.items.push(item.defaultData);

        state.active = item.type;
        activeModule(item.type, state.pageSet.items.length - 1)
      };
      // 移除模块
      const delMoudle = (index) => {
        state.pageSet.items.splice(index, 1);
        var items = state.pageSet.items
        if (items.length) {
          activeModule(items[items.length - 1].type, items.length - 1)
        } else {
          activeModule('page', -1)
        }
      };
      // 轮播图开始----------------------------
      // 追加图片数据
      const addImagesData = (index) => {
        modelRef.value.items[state.moduleIndex].data.push({ imgUrl: "", linkUrl: "" });
      };
      // 删除轮播图片数据
      const delImagesData = (index) => {
        if (modelRef.value.items[state.moduleIndex].data.length == 1) {
          message.error('至少要存在一个图片配置')
        } else {
          modelRef.value.items[state.moduleIndex].data.splice(index, 1)
        }
      }
      // 轮播图结束----------------------------
      // 保存当前模版数据
      const ruleForm = ref()
      const onSubmit = (type) => {
        ruleForm.value.validate().then(async (e) => {
          const hide = message.loading("正在加载中...", 0);
            let data = { ...state.form, content: JSON.stringify(state.pageSet) }
            var result = await setIntegralTemplate(data).then(res => res.data).catch(error => error)
            if (iscode(result, true)) {
              setTimeout(hide);
              state.moduleIndex = 0;
              getMore();
            }
          }).catch(error => {
            message.error('请完善模板！')
          })
      };
      // 拖动模块顺序
      // 记录初始信息
      const start_index = ref(0)
      const end_index = ref(0)
      const dragstart = (value, index) => {
        start_index.value = index;
      }
      // 做最终操作
      const dragend = (value) => {
        let oldValue = state.pageSet.items[start_index.value]
        let newValue = state.pageSet.items[end_index.value]
        let newItems = [...state.pageSet.items];
        newItems[start_index.value] = newValue
        newItems[end_index.value] = oldValue
        // this.items一改变，transition-group就起了作用
        state.pageSet.items = [...newItems];
        activeModule(value.type,end_index.value)
      }
      // 记录移动过程中信息
      const dragenter = (value, index) => {
        end_index.value = index
      }
      // 选择链接地址
      // 
      var father = ref(0)
      var children = ref(0)
      const onChooseLink = (findex, index) => {
        father.value = findex
        children.value = index
        state.linkVisible = true
      }
      // 选择链接
      const selecLink = (link) => {
        if (!link) return
        if (children.value == -1) {
          modelRef.value['items'][father.value].params.link = link
        } else {
          modelRef.value['items'][father.value].data[children.value].linkUrl = link
        }

        state.linkVisible = false
      }
      return {
        ...toRefs(state),
        modelRef,
        onSubmit,
        formCreateData,
        activeModule,
        addModule,
        delMoudle,
        addImagesData,
        delImagesData,
        dragenter,
        dragend,
        dragstart,
        onChooseLink,
        ruleForm,
        selecLink
      };
    },
  };
</script>
<style lang="less" scoped>
  .moduleContent {
    width: 285px;
    min-height: 600px;
    height: auto;
    background: #fdfdfd;
    border: 1px solid #ddd;
    padding: 15px 10px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    user-select: none;

    .moduleTitle {
      position: relative;
      padding-left: 22px;
      line-height: 30px;
      font-weight: 600;
      border-bottom: 1px solid #eef1f5;

      &::before {
        content: "";
        position: absolute;
        width: 4px;
        height: 13px;
        background: #204736;
        top: 10px;
        left: 9px;
      }
    }

    .navs {
      padding: 10px 5px;
      border-bottom: 1px dotted #ddd;
      position: relative;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;

      .navs-group {
        display: block;
        width: 100%;

        .title {
          font-size: 0.24rem;
          color: #999;
          margin: 10px 0;
        }

        .navs-components {
          display: flex;
          flex-wrap: wrap;
        }

        .special {
          background: #f4f4f4;
          width: 74px;
          padding: 3px 0;
          margin: 5px;
          border: 1px solid #dddddd;
          text-align: center;
          font-size: 12px;
          cursor: pointer;
        }

        p {
          color: #424242;
          font-size: 12px;
        }
      }
    }
  }

  .app-module {
    position: relative;
    &:hover {
      border: 2px dashed #f04635 !important;

      .app-module-del {
        display: block;
      }
    }

    .app-module-del {
      z-index: 100;
      display: none;
      position: absolute;
      right: 2px;
      bottom: 2px;
      color: #204736;
      font-size: 12px;
    }
  }

  .app-active-module {
    border: 2px dashed #f04635 !important;
  }

  .imagesContent {
    padding: 20px;
    background: #f7fafc;
    position: relative;
    border-radius: 3px;
    cursor: move;
    height: 240px;
    margin-bottom: 20px;

    .images_del {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }

  .navContent {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;

    .images_del {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }
  .taskContent{
    padding: 20px;
    background: #f7fafc;
    position: relative;
    border-radius: 3px;
    cursor: move;
    margin-bottom: 20px;

    .images_del {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }
  }
</style>